import React from 'react';
import { SettingsProvider } from './SettingsContext';
import { LogsProvider } from './LogsContext';
import { UIProvider } from './UIContext';
import { PreviewProvider } from './PreviewContext';
import { EditorStateProvider } from './EditorStateContext';

export { useSettings, SettingsProvider } from './SettingsContext';
export { useLogs, LogsProvider } from './LogsContext';
export { useUI, UIProvider, clamp } from './UIContext';
export { usePreviewContext, PreviewProvider } from './PreviewContext';
export { useEditorState, EditorStateProvider } from './EditorStateContext';

type AppProvidersProps = {
  children: React.ReactNode;
  initialCommitId?: string;
};

export function AppProviders({ children, initialCommitId }: AppProvidersProps) {
  return (
    <SettingsProvider>
      <LogsProvider>
        <UIProvider>
          <PreviewProvider>
            <EditorStateProvider initialCommitId={initialCommitId}>
              {children}
            </EditorStateProvider>
          </PreviewProvider>
        </UIProvider>
      </LogsProvider>
    </SettingsProvider>
  );
}
